// extracted by mini-css-extract-plugin
module.exports = {"description":"_02712f2b3b--description--IRi9P","link":"_02712f2b3b--link--BxETe","content":"_02712f2b3b--content--qZlgC","content-item":"_02712f2b3b--content-item--sPmPK"};